import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { baseUrl } from '@/utils/constants';
import { logError } from '@/utils/errorHandlerUtil';

import { useCustomFetch } from './useCustomFetch';
import { Star, StarStatus } from '@/models/Star';

export default function useStar() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();
  const starsUrl = `${baseUrl}stars`;
  const addStar = useCallback(
    async (star: Star): Promise<Star | null> => {
      const url = `${starsUrl}/add`;
      const newStarId = await customFetch<number>(url, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify(star),
      });

      if (newStarId == null || newStarId <= 0) {
        logError('Failed to add new star');
      }

      return { ...star, id: newStarId };
    },
    [starsUrl, customFetch, authResult.accessToken]
  );

  const updateStarStatus = useCallback(
    async (starId: number, newStarStatus: StarStatus): Promise<Star> => {
      const url = `${starsUrl}/${starId}/UpdateStarStatus`;
      const updatedStar = await customFetch<Star>(url, {
        method: 'PUT',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify({ starStatus: newStarStatus }),
      });

      return updatedStar;
    },
    [starsUrl, customFetch, authResult.accessToken]
  );

  return { addStar, updateStarStatus };
}
